// imgzoos
import kk from '../img/KK-zoo.png';
import cm from '../img/CM-zoo.png';
import kn from '../img/KN-zoo.png';
import nm from '../img/NM-zoo.png';
import sk from '../img/SK-zoo.png';
import ub from '../img/UB-zoo.png';
import Zpotlogo from '../img/ZPOT_LOGO.png';
import Addpay from '../img/addpay.png';

const imgzoos = [
  {
    id: 1,
    img: kk,
    name: "สวนสัตว์เปิดเขาเขียว",
  },
  {
    id: 2,
    img: cm,
    name: "สวนสัตว์เชียงใหม่",
  },
  {
    id: 3,
    img: nm,
    name: "สวนสัตว์นครราชสีมา",
  },
  {
    id: 4,
    img: ub,
    name: "สวนสัตว์อุบลราชธานี",
  },
  {
    id: 5,
    img: kn,
    name: "สวนสัตว์ขอนแก่น",
  },
  {
    id: 6,
    img: sk,
    name: "สวนสัตว์สงขลา",
  },

];

export default imgzoos;
